import React, { useCallback } from 'react';
import clsx from 'clsx';

import { SvgIcon } from 'components/helpers/SvgIcon';
import { BaseActionButtonProps } from '../BaseActionButtonProps';

import commonStyles from '../ActionButtonCommon.module.scss';
import CtaButton from '../../../Atoms/Cta/CtaButton';

interface PlaceholderButtonProps extends BaseActionButtonProps {
  filledPlaceholder: boolean;
}

export function PlaceholderButton({
  label,
  variant,
  filledPlaceholder,
}: PlaceholderButtonProps): JSX.Element {
  const handleClick = useCallback(() => {
    console.log('Placeholder button clicked:', label);
  }, [label]);

  const isFilledStyle = filledPlaceholder && variant === 'horizontal';

  const buttonClassName = isFilledStyle
    ? commonStyles.actionButtonBase
    : clsx(
        commonStyles.actionButtonBase,
        commonStyles.actionToolbarLink,
        commonStyles[`actionButton--${variant}`]
      );

  const iconClassName = clsx(commonStyles.icon);
  const labelClassName = clsx(commonStyles.label);

  return (
    <div
      className={clsx({
        [commonStyles['actionButtonWrapper--horizontal']]: variant === 'horizontal',
      })}
    >
      <CtaButton
        ctaStyle={variant === 'vertical' ? 'none' : 'filled'}
        ctaVariant="brand"
        type="button"
        onClick={handleClick}
        className={buttonClassName}
        ctaIconNoSpacer={variant === 'vertical'}
      >
        <SvgIcon
          icon="bullet-check-outline"
          size="sm"
          viewBox="0 0 24 24"
          className={iconClassName}
        />
        <span className={labelClassName}>{label}</span>
      </CtaButton>
    </div>
  );
}
